"use client";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import { useColorScheme } from "@mui/material/styles";
import { trackEvent } from "~/connectors/analytics.connector";
import { AnalyticsEvents } from "~/connectors/analyticsEvents";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export function ThemeModeToggle() {
  const { mode, setMode } = useColorScheme();

  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
      trackEvent(AnalyticsEvents.THEME_SWITCHED_TO_DARK);
    } else if (mode === "dark") {
      setMode("system");
      trackEvent(AnalyticsEvents.THEME_SWITCHED_TO_SYSTEM);
    } else {
      setMode("light");
      trackEvent(AnalyticsEvents.THEME_SWITCHED_TO_LIGHT);
    }
  };

  const getIcon = () => {
    switch (mode) {
      case "light":
        return <Brightness7Icon />;
      case "dark":
        return <Brightness4Icon />;
      case "system":
        return <SettingsBrightnessIcon />;
      default:
        return <Brightness7Icon />;
    }
  };

  const getTooltip = () => {
    switch (mode) {
      case "light":
        return "Comută la modul întunecat";
      case "dark":
        return "Comută la modul sistem";
      case "system":
        return "Comută la modul luminos";
      default:
        return "Comută tema";
    }
  };

  if (!mode) {
    return null;
  }

  return (
    <Tooltip title={getTooltip()}>
      <IconButton
        onClick={toggleMode}
        color="inherit"
        size="small"
        sx={{
          color: "text.secondary",
          "&:hover": {
            color: "primary.main",
          },
        }}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
}
